import React from 'react';
import closeIcon from '../assets/Images/close-icon-13613.png';
const PopupCloseMessage = ({ onClose,text,className }) => {
  return (
    <div className="popupMessage">
      <a className={'align-content-end close'} onClick={onClose}><img width={'15'} src={closeIcon}/></a>
        <span  className="popupText mx-2 fs-7">{text}</span>

      <style>
        {`
          .popupMessage {
            position: fixed;
            bottom: 20px;
            right: 20px;
            background-color: #b04848;
            padding: 10px;
            border-radius: 5px;
            color:black;
            transition:all 0.3s ease
          }
          .popupMessage:hover{
            background-color: #983e3e;            
          }
          .popupText {
            margin-bottom: 10px;
          }
        `}
      </style>
    </div>
  );
};

export default PopupCloseMessage;